import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class PrintFormatsService {
  env = environment.env;
  printFormatsURL = endpointsURL.printFormatsURL;

  constructor(private httpClient: HttpClient) {}

  public listPrintFormats(filters: string) {
    return this.httpClient.get(
      `${this.env}${this.printFormatsURL}lista${filters}`
    );
  }

  public createPrintFormat(printFormat) {
    return this.httpClient.post(
      `${this.env}${this.printFormatsURL}edit`,
      printFormat
    );
  }

  public updatePrintFormat(printFormat) {
    return this.httpClient.put(
      `${this.env}${this.printFormatsURL}edit`,
      printFormat
    );
  }

  public removePrintFormat(ids) {
    let params = new HttpParams();

    ids.forEach((e) => {
      params = params.append("_identificadores", e);
    });
    return this.httpClient.delete(`${this.env}${this.printFormatsURL}edit`, {
      params: params,
    });
  }

  public getPrintFormatById(id) {
    let params = new HttpParams().set("_identificador", id);
    return this.httpClient.get(`${this.env}${this.printFormatsURL}edit`, {
      params: params,
    });
  }

  public getFieldOfPrintFormatById(idFormatoImpresion, idFieldOfFormat) {
    let params = new HttpParams();
    params = params.append("_campo", idFieldOfFormat);
    params = params.append("_identificador", idFormatoImpresion);

    return this.httpClient.get(
      `${this.env}${this.printFormatsURL}edit/camposformato`,
      {
        params: params,
      }
    );
  }

  public updateFieldOfPrintFormat(fieldPrintFormat) {
    return this.httpClient.put(
      `${this.env}${this.printFormatsURL}edit/camposformato`,
      fieldPrintFormat
    );
  }

  public listFieldsByPrintFormat(filters: string, ifFormato) {
    let params = new HttpParams().set("cIfFormato", ifFormato);
    return this.httpClient.get(
      `${this.env}${this.printFormatsURL}edit/formatoimpresion${filters}`,
      { params: params }
    );
  }
}
